import React from 'react';
import { X } from 'lucide-react';

/**
 * BulkActionBar — slides in when rows are selected. Sticky at top of table.
 *
 *   <BulkActionBar count={sel.count} onClear={sel.clear}>
 *     <button onClick={...}>Delete selected</button>
 *     <button onClick={...}>Export selected</button>
 *   </BulkActionBar>
 */
export default function BulkActionBar({ count, onClear, children, className = '' }) {
  if (!count) return null;
  return (
    <div
      className={`flex items-center justify-between gap-3 flex-wrap bg-[#1F7A6E] text-white rounded-sm px-3 py-2 ${className}`}
      data-testid="bulk-action-bar"
    >
      <div className="flex items-center gap-2 text-sm">
        <span className="text-[10px] font-display font-bold uppercase tracking-[0.18em] bg-white/20 px-2 py-0.5 rounded-sm">
          {count} selected
        </span>
        <button type="button" onClick={onClear} className="text-white/80 hover:text-white flex items-center gap-1 text-xs" data-testid="bulk-clear">
          <X size={12} /> Clear
        </button>
      </div>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}
